import { Route, Redirect } from "react-router-dom";
import PropTypes from "prop-types";

type PrivateRouteProps = {
  authed: boolean,
  children: React.ReactElement,
  path?: string,
  exact?: boolean,
};

function PrivateRoute({ children, authed, ...rest }: PrivateRouteProps) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        authed ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

// Si no usas TS, mantén PropTypes para evitar el warning
PrivateRoute.propTypes = {
  authed: PropTypes.bool.isRequired,
  children: PropTypes.element.isRequired,
};

export default PrivateRoute;
